import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Home from "./Pages/Home";
import History from "./Pages/History";
import VisionMission from "./Pages/VisionMission";
import ManagementCommitee from "./Pages/ManagementCommitee";
import JuniorBoard from "./Pages/JuniorBoard";
import PrincipalsMessage from "./Pages/PrincipalsMessage";
import SeniorBoard from "./Pages/SeniorBoard";
import SchoolVideos from "./Pages/SchoolVideos";
import SchoolInformation from "./Pages/SchoolInformation";
import SchoolLibrary from "./Pages/SchoolLibrary";
import SmartClassrooms from "./Pages/SmartClassrooms";
import ComputerEducation from "./Pages/ComputerEducation";
import SchoolTransport from "./Pages/SchoolTransport";
import MiRoom from "./Pages/MiRoom";
import AbsenceLeave from "./Pages/AbsenceLeave";
import AudioVisualRoom from "./Pages/AudioVisualRoom";
import ArtCraft from "./Pages/ArtCraft";
import BoardingHouse from "./Pages/BoardingHouse";
import BookShop from "./Pages/BookShop";
import BusRoutes from "./Pages/BusRoutes";
import BusRules from "./Pages/BusRules";
import Canteen from "./Pages/Canteen";
import CodeConduct from "./Pages/CodeConduct";
import DanceMusic from "./Pages/DanceMusic";
import Laboratory from "./Pages/Laboratory";
import LibraryRules from "./Pages/LibraryRules";
import MultiPurposeHall from "./Pages/MultiPurposeHall";
import PaymentFees from "./Pages/PaymentFees";
import SchoolCounsellor from "./Pages/SchoolCounsellor";
import Sports from "./Pages/Sports";
import TransportRules from "./Pages/TransportRules";
import UniformShop from "./Pages/UniformShop";
import Footer from "./Component/Footer";
import InterSchoolCorner from "./Pages/InterSchoolCorner";
import AdmissionServing from "./Pages/AdmissionServing";
import BookList from "./Pages/BookList";
import ClassTeacherListJunior from "./Pages/ClassTeacherListJunior";
import ClassTeacherListSenior from "./Pages/ClassTeacherListSenior";
import ClassXIOptionForm from "./Pages/ClassXIOptionForm";
import Clubs from "./Pages/Clubs";
import CyberSafety from "./Pages/CyberSafety";
import FeeStructure from "./Pages/FeeStructure";
import HealthPhysicalEducationForms from "./Pages/HealthPhysicalEducationForms";
import HouseSystem from "./Pages/HouseSystem";
import JuniorExamination from "./Pages/JuniorExamination";
import PlannerJunior from "./Pages/PlannerJunior";
import PlannerSenior from "./Pages/PlannerSenior";
import PortfolioTemplate from "./Pages/PortfolioTemplate";
import ProformaForVerificationService from "./Pages/ProformaForVerificationService";
import ResultAnalysis from "./Pages/ResultAnalysis";
import SchoolCalendar from "./Pages/SchoolCalendar";
import SeniorExamination from "./Pages/SeniorExamination";
import UKGAdmissions from "./Pages/UKGAdmissions";
import MandatoryPublicDisclosure from "./Pages/MandatoryPublicDisclosure";
import Recruitment from "./Pages/Recruitment";
import ClassesUKGtoV from "./Pages/ClassesUKGtoV";
import CarryingParentguardian from "./Pages/CarryingParentguardian";
import SchoolUniform from "./Pages/SchoolUniform";
import Withdrawal from "./Pages/Withdrawal";
import SchoolTiming from "./Pages/SchoolTiming";
import SchoolTransportUKGtoXII from "./Pages/SchoolTransportUKGtoXII";
import Houses from "./Pages/Houses";
import ClassesVItovIII from "./Pages/ClassesVItovIII";
import ClassesIXtoX from "./Pages/ClassesIXtoX";
import ClassesXItoXII from "./Pages/ClassesXItoXII";
import Faq from "./Pages/Faq";
import HomeworkSchedule from "./Pages/HomeworkSchedule";
import ContactUs from "./Pages/ContactUs";
import TenderNotice from "./Pages/TenderNotice";
import PreventiveMeasures from "./Pages/PreventiveMeasures";
import CatalystBoardCorner from "./Pages/CatalystBoardCorner";
import CareerCornerMissionMole from "./Pages/CareerCornerMissionMole";
import AlumniForm from "./Pages/AlumniForm";
import Tc from "./Pages/Tc";
import SubGallery from "./Pages/SubGallery";
import News from "./Pages/News";
import Gallery from "./Pages/Gallery";
import HomeWork from "./Pages/HomeWork";
import Circular from "./Pages/Circular";
import Achievements from "./Pages/Achievements";
import SportActivites from "./Pages/SportActivites";
import JuniorWing from "./Pages/JuniorWing";
import Magazine from "./Pages/Magazine";
import Events from "./Pages/Events";
import Alumni from "./Pages/Alumni";
import SchoolEvents from "./Pages/SchoolEvents";
import Library from "./Pages/Library";
import JuniorLibrary from "./Pages/JuniorLibrary";
import SeniorLibrary from "./Pages/SeniorLibrary";
import SportsActivitiesData from "./Pages/SportsActivitiesData";
import AchievementsData from "./Pages/AchievementsData";
import TopperX from "./Pages/TopperX";
import TopperXII from "./Pages/TopperXII";
import RaisingDay from "./Pages/RaisingDay";
import RaisingDay2026 from "./Pages/RaisingDay2026";

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="*" element={<Navigate to="/" />} />
          <Route path="/History" element={<History />} />
          <Route path="/VisionMission" element={<VisionMission />} />
          <Route path="/ManagementCommitee" element={<ManagementCommitee />} />
          <Route path="/PrincipalsMessage" element={<PrincipalsMessage />} />
          <Route path="/JuniorBoard" element={<JuniorBoard />} />
          <Route path="/SeniorBoard" element={<SeniorBoard />} />
          <Route path="/SchoolVideos" element={<SchoolVideos />} />
          <Route path="/SchoolInformation" element={<SchoolInformation />} />
          <Route path="/SchoolLibrary" element={<SchoolLibrary />} />
          <Route path="/SmartClassrooms" element={<SmartClassrooms />} />
          <Route path="/ComputerEducation" element={<ComputerEducation />} />
          <Route path="/SchoolTransport" element={<SchoolTransport />} />
          <Route path="/AbsenceLeave" element={<AbsenceLeave />} />
          <Route path="/MiRoom" element={<MiRoom />} />
          <Route path="/ArtCraft" element={<ArtCraft />} />
          <Route path="/AudioVisualRoom" element={<AudioVisualRoom />} />
          <Route path="/BoardingHouse" element={<BoardingHouse />} />
          <Route path="/BookShop" element={<BookShop />} />
          <Route path="/BusRoutes" element={<BusRoutes />} />
          <Route path="/BusRules" element={<BusRules />} />
          <Route path="/Canteen" element={<Canteen />} />
          <Route path="/CodeConduct" element={<CodeConduct />} />
          <Route path="/DanceMusic" element={<DanceMusic />} />
          <Route path="/LibraryRules" element={<LibraryRules />} />
          <Route path="/MultiPurposeHall" element={<MultiPurposeHall />} />
          <Route path="/PaymentFees" element={<PaymentFees />} />
          <Route path="/SchoolCounsellor" element={<SchoolCounsellor />} />
          <Route path="/Laboratory" element={<Laboratory />} />
          <Route path="/Sports" element={<Sports />} />
          <Route path="/TransportRules" element={<TransportRules />} />
          <Route path="/UniformShop" element={<UniformShop />} />
          <Route path="/InterSchoolCorner" element={<InterSchoolCorner />} />
          <Route path="/AdmissionServing" element={<AdmissionServing />} />
          <Route path="/BookList" element={<BookList />} />
          <Route
            path="/ClassTeacherListJunior"
            element={<ClassTeacherListJunior />}
          />
          <Route
            path="/ClassTeacherListSenior"
            element={<ClassTeacherListSenior />}
          />
          <Route path="/ClassXIOptionForm" element={<ClassXIOptionForm />} />
          <Route path="/Clubs" element={<Clubs />} />
          <Route path="/CyberSafety" element={<CyberSafety />} />
          <Route path="/FeeStructure" element={<FeeStructure />} />
          <Route
            path="/HealthPhysicalEducationForms"
            element={<HealthPhysicalEducationForms />}
          />
          <Route path="/HouseSystem" element={<HouseSystem />} />
          <Route path="/JuniorExamination" element={<JuniorExamination />} />
          <Route path="/PlannerJunior" element={<PlannerJunior />} />
          <Route path="/PlannerSenior" element={<PlannerSenior />} />
          <Route path="/PortfolioTemplate" element={<PortfolioTemplate />} />
          <Route
            path="/ProformaForVerificationService"
            element={<ProformaForVerificationService />}
          />
          <Route path="/ResultAnalysis" element={<ResultAnalysis />} />
          <Route path="/SchoolCalendar" element={<SchoolCalendar />} />
          <Route path="/SeniorExamination" element={<SeniorExamination />} />
          <Route path="/UKGAdmissions" element={<UKGAdmissions />} />
          <Route
            path="/MandatoryPublicDisclosure"
            element={<MandatoryPublicDisclosure />}
          />
          <Route path="/Recruitment" element={<Recruitment />} />
          <Route path="/ClassesUKGtoV" element={<ClassesUKGtoV />} />
          <Route
            path="/CarryingParentguardian"
            element={<CarryingParentguardian />}
          />
          <Route path="/SchoolUniform" element={<SchoolUniform />} />
          <Route path="/Withdrawal" element={<Withdrawal />} />
          <Route path="/SchoolTiming" element={<SchoolTiming />} />
          <Route
            path="/SchoolTransportUKGtoXII"
            element={<SchoolTransportUKGtoXII />}
          />
          <Route path="/Houses" element={<Houses />} />
          <Route path="/ClassesVItovIII" element={<ClassesVItovIII />} />
          <Route path="/ClassesIXtoX" element={<ClassesIXtoX />} />
          <Route path="/ClassesXItoXII" element={<ClassesXItoXII />} />
          <Route path="/Faq" element={<Faq />} />
          <Route path="/ContactUs" element={<ContactUs />} />
          <Route path="/HomeworkSchedule" element={<HomeworkSchedule />} />
          <Route path="/TenderNotice" element={<TenderNotice />} />
          <Route path="/PreventiveMeasures" element={<PreventiveMeasures />} />
          <Route
            path="/CatalystBoardCorner"
            element={<CatalystBoardCorner />}
          />
          <Route
            path="/CareerCornerMissionMole"
            element={<CareerCornerMissionMole />}
          />
          <Route path="/AlumniForm" element={<AlumniForm />} />
          <Route path="/Tc" element={<Tc />} />
          <Route path="/SubGallery" element={<SubGallery />} />
          <Route path="/News" element={<News />} />
          <Route path="/Gallery" element={<Gallery />} />
          <Route path="/HomeWork" element={<HomeWork />} />
          <Route path="/Circular" element={<Circular />} />
          <Route path="/Achievements" element={<Achievements />} />
          <Route path="/SportActivites" element={<SportActivites />} />
          <Route path="/JuniorWing" element={<JuniorWing />} />
          <Route path="/Magazine" element={<Magazine />} />
          <Route path="/Events" element={<Events />} />
          <Route path="/Alumni" element={<Alumni />} />
          <Route path="/SchoolEvents" element={<SchoolEvents />} />
          <Route path="/Library" element={<Library />} />
          <Route path="/JuniorLibrary" element={<JuniorLibrary />} />
          <Route path="/SeniorLibrary" element={<SeniorLibrary />} />
          <Route
            path="/SportsActivitiesData"
            element={<SportsActivitiesData />}
          />
          <Route path="/AchievementsData" element={<AchievementsData />} />
          <Route path="/TopperX" element={<TopperX />} />
          <Route path="/TopperXII" element={<TopperXII />} />
          <Route path="/RaisingDay" element={<RaisingDay />} />
          <Route path="/RaisingDay2026" element={<RaisingDay2026 />} />
        </Routes>
        <Footer />
      </Router>
    </>
  );
}

export default App;
